import { render, staticRenderFns } from "./AnnualLeavePaginationWidget.vue?vue&type=template&id=6709114d&scoped=true"
import script from "./AnnualLeavePaginationWidget.vue?vue&type=script&lang=js"
export * from "./AnnualLeavePaginationWidget.vue?vue&type=script&lang=js"
import style0 from "./AnnualLeavePaginationWidget.vue?vue&type=style&index=0&id=6709114d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6709114d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VPagination } from 'vuetify/lib/components/VPagination';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VCard,VCardText,VCol,VDataTable,VIcon,VPagination,VRow,VSkeletonLoader})
